import axios from 'axios';

export default {
  async LOAD_bills({ commit }) {
    const response = await axios.get('api/recon/bills');
    commit('SET_bills', response.data);
  },
  async RUN_recon() {
    await axios.get('/jobs/run/recon');
  },
};
